import React from 'react';
import { BrowserRouter, Switch, Route, withRouter } from 'react-router-dom';

import AboutMe from '../views/aboutMe/AboutMe.jsx'
import Services from '../views/services/Services.jsx'
import Products from '../views/products/Products.jsx'
import Contact from '../views/contact/Contact.jsx'
import Home from '../views/home/HomeView.jsx'

import { ROOT, SERVICES_PATH, PRODUCTS_PATH, CONTACT_PATH, ABOUT_US_PATH } from './Routes';

const Router = () => {
    return(
    
    <BrowserRouter>
        <Switch>
            <Route exact path={ROOT} component={withRouter(Home)} />
            <Route path={SERVICES_PATH} component={withRouter(Services)}/>
            <Route path={PRODUCTS_PATH} component={withRouter(Products)}/>
            <Route path={CONTACT_PATH} component={withRouter(Contact)}/>
            <Route path={ABOUT_US_PATH} component={withRouter(AboutMe)}/>
        </Switch>
    </BrowserRouter>

    )
}

export default Router